import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const OboutImage = require("../../../Assets/Images/canva/canvaAbout.png");
const QrImage = require("../../../Assets/Images/canva/canvaQr.png");
const ObonAbout = () => {
  let { t } = useTranslation();
  return (
    <section id="canvaAbout" className="BannerImgTwo">
      <Container fluid className="h-100">
        <Row className="justify-content-bettwen align-items-center h-100 px-4 pt-3">
          <Col md={6} sm={12} className="h-100">
            <Col md={12}>
              <div className="py-3 h-100">
                <h3
                  className="heading mb-3"
                  style={{ letterSpacing: "3px", position: "relative" }}
                >
                  {t("AboutUs")}
                </h3>
                <p className="canvaText text-sm-start mb-3 w-100">
                  {/* {t("AboutUsTextFirst")} */}
                  Our mission at EasyTipping is to revolutionize the tipping
                  experience for service-based employees and business owners.
                </p>
                <p className="canvaText text-sm-start mb-3">
                  {/* {t("AboutUsTextFirst")} */}
                  Our cashless tip management systems empower users by
                  broadening their financial prospects and providing a
                  streamlined experience at every touchpoint.
                </p>
                <p className="canvaText mb-3">
                  {/* {t("AboutUsText2nd")} */}
                  Our core values are at the heart of all that we do: Service
                  Excellence, Convenience, Fairness, Transparency.
                </p>
              </div>
            </Col>

            <Col md={12} className="text-center mt-3 mb-3">
              <img className="img-fluid w-25" src={QrImage} alt="" />
            </Col>
          </Col>
          <Col md={6} sm={12} className="h-100">
            <div className="w-100 h-100 mb-3 text-center">
              <img className="img-fluid w-75" src={OboutImage} alt="" />
            </div>
            <Col >
              <div className="text-center mt-3">
              <img className="img-fluid w-25" src={QrImage} alt="" />
              </div>
     
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ObonAbout;
